<template>
    <DashboardCard
            :width="width"
            :dataDisplay="dataDisplay"
            dataValueFormatFilter="currency"
            :main_icon="main_icon"
            :icons="icons"
            :load_url="load_url"
            :title="title"
            :under_title="under_title">
    </DashboardCard>
</template>


<script>
    import DashboardCard from '../../widgets/DashboardCard';
    export default {
        name: 'CurrentPaidGoods',
        components: {DashboardCard},
        props: {
            width: {type:Number, default: 25},
            dataDisplay: {type:String, default: null},
        },
        data() {
            var labels = [];
            return {
                main_icon: 'fa-light fa-money-bill-alt',
                title: 'Current Value of Paid Goods',
                under_title: null,
                load_url: '/dashboards/CurrentPaidGoods',
                icons: labels,
            };
        },
    };
</script>

<style scoped>

</style>